/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectListPage_QueryVariables = {
    loadSingleCurrency: boolean;
    loadMultiCurrency: boolean;
    excludeDoneOrHalted: boolean;
    excludeGroupProjectsFromProjectConnection: boolean;
};
export type ProjectListPage_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ProjectListPage_viewer">;
    } | null;
};
export type ProjectListPage_Query = {
    readonly response: ProjectListPage_QueryResponse;
    readonly variables: ProjectListPage_QueryVariables;
};



/*
query ProjectListPage_Query(
  $loadSingleCurrency: Boolean!
  $loadMultiCurrency: Boolean!
  $excludeDoneOrHalted: Boolean!
  $excludeGroupProjectsFromProjectConnection: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "overview_projects")
    ...ProjectListPage_viewer_27Dvtq
    id
  }
}

fragment ProjectListPage_viewer_27Dvtq on Viewer {
  id
  backendId
  firstName
  actualPersonId
  availableFeatureFlags {
    key
    id
  }
  client {
    id
  }
  filters(first: 1000000, filterSection: PROJECTS_OVERVIEW) {
    edges {
      node {
        id
        name
        section
        value
        updatedAt
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  company {
    currency
    xeroEnabled
    sageIntacctConnectionEnabled
    sageIntacctTimeRegsFromForecast
    priorityLevels {
      edges {
        node {
          id
        }
      }
    }
    id
  }
  projectGroups(first: 1000000, excludeDoneOrHalted: $excludeDoneOrHalted) {
    edges {
      node {
        id
        companyProjectGroupId
        name
        color
        projects(first: 1000000) {
          edges {
            node {
              id
              status
              name
              budgetType
              isInProjectGroup
              readOnlyAccess
              description
              projectStartDay
              projectStartMonth
              projectStartYear
              projectEndDay
              projectEndMonth
              projectEndYear
              companyProjectId
              customProjectId
              client {
                id
                name
                logoId
                logoDefaultId
              }
              rateCard {
                id
                name
                currency
                parentRateCardId
              }
              projectLabels(first: 10000) {
                edges {
                  node {
                    label {
                      id
                      name
                      color
                    }
                    id
                  }
                }
              }
              projectColor
              currentProjectStatus {
                id
                color
                person {
                  firstName
                  lastName
                  id
                }
              }
              priorityLevel {
                id
                name
                weight
              }
              projectPersons(first: 1000000, contactsOnly: true) {
                edges {
                  node {
                    id
                    isContactPerson
                    person {
                      id
                      firstName
                      lastName
                      profilePictureId
                      profilePictureDefaultId
                      initials
                    }
                  }
                }
              }
              statusColor
              budget
              budgetBaseCurrency
              estimationUnit
              minutesPerEstimationPoint
              baselineWinChance
              sprintTimeBox
              progress
              manualProgressOnProjectEnabled
              manualProgressOnPhasesEnabled
              manualProgressOnTasksEnabled
              financialNumbers @include(if: $loadMultiCurrency) {
                billablePlannedTimeAndExpenses
                actualRevenue
                remainingRevenue
                forecastRevenue
                recognitionOpenRevenue
                recognitionForecastRevenue
                recognitionLockedRevenue
                plannedCost
                actualCost
                forecastCost
                remainingCost
                plannedProfit
                forecastProfit
                invoiced
                paid
              }
  financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {
                billablePlannedTimeAndExpenses
                actualRevenue
                remainingRevenue
                forecastRevenue
                recognitionOpenRevenue
                recognitionForecastRevenue
                recognitionLockedRevenue
                plannedCost
                actualCost
                forecastCost
                remainingCost
                plannedProfit
                forecastProfit
                invoiced
                paid
              }
              financialNumbers @include(if: $loadSingleCurrency) {
                billablePlannedTimeAndExpenses
                actualRevenue
                remainingRevenue
                forecastRevenue
                recognitionOpenRevenue
                recognitionForecastRevenue
                recognitionLockedRevenue
                plannedCost
                actualCost
                forecastCost
                remainingCost
                plannedProfit
                forecastProfit
                invoiced
                paid
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  projects(first: 1000000, excludeRestricted: true, excludeGroupProjects: $excludeGroupProjectsFromProjectConnection, excludeDoneOrHalted: $excludeDoneOrHalted) {
    edges {
      node {
        id
        name
        budgetType
        status
        description
        statusColor
        companyProjectId
        readOnlyAccess
        budget
        budgetBaseCurrency
        projectColor
        estimationUnit
        minutesPerEstimationPoint
        projectStartDay
        projectStartMonth
        projectStartYear
        projectEndDay
        projectEndMonth
        projectEndYear
        baselineWinChance
        sprintTimeBox
        currentProjectStatus {
          id
          color
          person {
            id
            firstName
            lastName
          }
        }
        client {
          id
          name
          logoId
          logoDefaultId
        }
        rateCard {
          id
          name
          currency
          parentRateCardId
        }
        progress
        manualProgressOnProjectEnabled
        manualProgressOnPhasesEnabled
        manualProgressOnTasksEnabled
        priorityLevel {
          id
          name
          weight
        }
        projectLabels(first: 10000) {
          edges {
            node {
              id
              label {
                id
                name
                color
              }
            }
          }
        }
        projectPersons(first: 1000000, contactsOnly: true) {
          edges {
            node {
              id
              isContactPerson
              person {
                id
                firstName
                lastName
                profilePictureId
                profilePictureDefaultId
                initials
              }
            }
          }
        }
        financialNumbers @include(if: $loadMultiCurrency) {
          billablePlannedTimeAndExpenses
          actualRevenue
          remainingRevenue
          forecastRevenue
          recognitionOpenRevenue
          recognitionForecastRevenue
          recognitionLockedRevenue
          plannedCost
          actualCost
          forecastCost
          remainingCost
          plannedProfit
          forecastProfit
          invoiced
          paid
        }
  financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {
          billablePlannedTimeAndExpenses
          actualRevenue
          remainingRevenue
          forecastRevenue
          recognitionOpenRevenue
          recognitionForecastRevenue
          recognitionLockedRevenue
          plannedCost
          actualCost
          forecastCost
          remainingCost
          plannedProfit
          forecastProfit
          invoiced
          paid
        }
        financialNumbers @include(if: $loadSingleCurrency) {
          billablePlannedTimeAndExpenses
          actualRevenue
          remainingRevenue
          forecastRevenue
          recognitionOpenRevenue
          recognitionForecastRevenue
          recognitionLockedRevenue
          plannedCost
          actualCost
          forecastCost
          remainingCost
          plannedProfit
          forecastProfit
          invoiced
          paid
        }
        isInProjectGroup
        customProjectId
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "loadSingleCurrency",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "loadMultiCurrency",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeDoneOrHalted",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeGroupProjectsFromProjectConnection",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "overview_projects"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"overview_projects\")"
},
v3 = {
  "kind": "Variable",
  "name": "excludeDoneOrHalted",
  "variableName": "excludeDoneOrHalted"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = [
  (v4/*: any*/)
],
v7 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v8 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "PROJECTS_OVERVIEW"
  },
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v14 = [
  (v3/*: any*/),
  (v7/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoDefaultId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRateCardId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityLevel",
  "kind": "LinkedField",
  "name": "priorityLevel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "contactsOnly",
      "value": true
    },
    (v7/*: any*/)
  ],
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isContactPerson",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/),
                (v34/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureDefaultId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "initials",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetBaseCurrency",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineWinChance",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v48 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billablePlannedTimeAndExpenses",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionOpenRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionForecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionLockedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "invoiced",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "paid",
    "storageKey": null
  }
],
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "financialNumbers",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v50 = {
  "condition": "loadMultiCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v49/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbersProjectCurrency",
      "plural": false,
      "selections": (v48/*: any*/),
      "storageKey": null
    }
  ]
},
v51 = {
  "condition": "loadSingleCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v49/*: any*/)
  ]
},
v52 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "excludeGroupProjects",
    "variableName": "excludeGroupProjectsFromProjectConnection"
  },
  {
    "kind": "Literal",
    "name": "excludeRestricted",
    "value": true
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectListPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "excludeGroupProjectsFromProjectConnection",
                "variableName": "excludeGroupProjectsFromProjectConnection"
              },
              {
                "kind": "Variable",
                "name": "loadMultiCurrency",
                "variableName": "loadMultiCurrency"
              },
              {
                "kind": "Variable",
                "name": "loadSingleCurrency",
                "variableName": "loadSingleCurrency"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ProjectListPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectListPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backendId",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": "filters(filterSection:\"PROJECTS_OVERVIEW\",first:1000000)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xeroEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctConnectionEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctTimeRegsFromForecast",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PriorityLevelTypeConnection",
                "kind": "LinkedField",
                "name": "priorityLevels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PriorityLevelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriorityLevel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "ProjectGroupTypeConnection",
            "kind": "LinkedField",
            "name": "projectGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectGroupTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyProjectGroupId",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          (v7/*: any*/)
                        ],
                        "concreteType": "ProjectTypeConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v16/*: any*/),
                                  (v9/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v31/*: any*/),
                                    "concreteType": "ProjectLabelTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "projectLabels",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectLabelTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProjectLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v32/*: any*/),
                                              (v4/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "projectLabels(first:10000)"
                                  },
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectStatus",
                                    "kind": "LinkedField",
                                    "name": "currentProjectStatus",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v34/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projects(first:1000000)"
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_projectGroups",
            "kind": "LinkedHandle",
            "name": "projectGroups"
          },
          {
            "alias": null,
            "args": (v52/*: any*/),
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      (v17/*: any*/),
                      (v16/*: any*/),
                      (v20/*: any*/),
                      (v37/*: any*/),
                      (v27/*: any*/),
                      (v19/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v33/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectStatus",
                        "kind": "LinkedField",
                        "name": "currentProjectStatus",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v34/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": (v31/*: any*/),
                        "concreteType": "ProjectLabelTypeConnection",
                        "kind": "LinkedField",
                        "name": "projectLabels",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectLabelTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v32/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projectLabels(first:10000)"
                      },
                      (v36/*: any*/),
                      (v18/*: any*/),
                      (v28/*: any*/),
                      (v10/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v52/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_projects",
            "kind": "LinkedHandle",
            "name": "projects"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ProjectListPage_Query",
    "operationKind": "query",
    "text": "query ProjectListPage_Query(\n  $loadSingleCurrency: Boolean!\n  $loadMultiCurrency: Boolean!\n  $excludeDoneOrHalted: Boolean!\n  $excludeGroupProjectsFromProjectConnection: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"overview_projects\")\n    ...ProjectListPage_viewer_27Dvtq\n    id\n  }\n}\n\nfragment ProjectListPage_viewer_27Dvtq on Viewer {\n  id\n  backendId\n  firstName\n  actualPersonId\n  availableFeatureFlags {\n    key\n    id\n  }\n  client {\n    id\n  }\n  filters(first: 1000000, filterSection: PROJECTS_OVERVIEW) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  company {\n    currency\n    xeroEnabled\n    sageIntacctConnectionEnabled\n    sageIntacctTimeRegsFromForecast\n    priorityLevels {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  projectGroups(first: 1000000, excludeDoneOrHalted: $excludeDoneOrHalted) {\n    edges {\n      node {\n        id\n        companyProjectGroupId\n        name\n        color\n        projects(first: 1000000) {\n          edges {\n            node {\n              id\n              status\n              name\n              budgetType\n              isInProjectGroup\n              readOnlyAccess\n              description\n              projectStartDay\n              projectStartMonth\n              projectStartYear\n              projectEndDay\n              projectEndMonth\n              projectEndYear\n              companyProjectId\n              customProjectId\n              client {\n                id\n                name\n                logoId\n                logoDefaultId\n              }\n              rateCard {\n                id\n                name\n                currency\n                parentRateCardId\n              }\n              projectLabels(first: 10000) {\n                edges {\n                  node {\n                    label {\n                      id\n                      name\n                      color\n                    }\n                    id\n                  }\n                }\n              }\n              projectColor\n              currentProjectStatus {\n                id\n                color\n                person {\n                  firstName\n                  lastName\n                  id\n                }\n              }\n              priorityLevel {\n                id\n                name\n                weight\n              }\n              projectPersons(first: 1000000, contactsOnly: true) {\n                edges {\n                  node {\n                    id\n                    isContactPerson\n                    person {\n                      id\n                      firstName\n                      lastName\n                      profilePictureId\n                      profilePictureDefaultId\n                      initials\n                    }\n                  }\n                }\n              }\n              statusColor\n              budget\n              budgetBaseCurrency\n              estimationUnit\n              minutesPerEstimationPoint\n              baselineWinChance\n              sprintTimeBox\n              progress\n              manualProgressOnProjectEnabled\n              manualProgressOnPhasesEnabled\n              manualProgressOnTasksEnabled\n              financialNumbers @include(if: $loadMultiCurrency) {\n                billablePlannedTimeAndExpenses\n                actualRevenue\n                remainingRevenue\n                forecastRevenue\n                recognitionOpenRevenue\n                recognitionForecastRevenue\n                recognitionLockedRevenue\n                plannedCost\n                actualCost\n                forecastCost\n                remainingCost\n                plannedProfit\n                forecastProfit\n                invoiced\n                paid\n              }\n  financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {\n                billablePlannedTimeAndExpenses\n                actualRevenue\n                remainingRevenue\n                forecastRevenue\n                recognitionOpenRevenue\n                recognitionForecastRevenue\n                recognitionLockedRevenue\n                plannedCost\n                actualCost\n                forecastCost\n                remainingCost\n                plannedProfit\n                forecastProfit\n                invoiced\n                paid\n              }\n              financialNumbers @include(if: $loadSingleCurrency) {\n                billablePlannedTimeAndExpenses\n                actualRevenue\n                remainingRevenue\n                forecastRevenue\n                recognitionOpenRevenue\n                recognitionForecastRevenue\n                recognitionLockedRevenue\n                plannedCost\n                actualCost\n                forecastCost\n                remainingCost\n                plannedProfit\n                forecastProfit\n                invoiced\n                paid\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  projects(first: 1000000, excludeRestricted: true, excludeGroupProjects: $excludeGroupProjectsFromProjectConnection, excludeDoneOrHalted: $excludeDoneOrHalted) {\n    edges {\n      node {\n        id\n        name\n        budgetType\n        status\n        description\n        statusColor\n        companyProjectId\n        readOnlyAccess\n        budget\n        budgetBaseCurrency\n        projectColor\n        estimationUnit\n        minutesPerEstimationPoint\n        projectStartDay\n        projectStartMonth\n        projectStartYear\n        projectEndDay\n        projectEndMonth\n        projectEndYear\n        baselineWinChance\n        sprintTimeBox\n        currentProjectStatus {\n          id\n          color\n          person {\n            id\n            firstName\n            lastName\n          }\n        }\n        client {\n          id\n          name\n          logoId\n          logoDefaultId\n        }\n        rateCard {\n          id\n          name\n          currency\n          parentRateCardId\n        }\n        progress\n        manualProgressOnProjectEnabled\n        manualProgressOnPhasesEnabled\n        manualProgressOnTasksEnabled\n        priorityLevel {\n          id\n          name\n          weight\n        }\n        projectLabels(first: 10000) {\n          edges {\n            node {\n              id\n              label {\n                id\n                name\n                color\n              }\n            }\n          }\n        }\n        projectPersons(first: 1000000, contactsOnly: true) {\n          edges {\n            node {\n              id\n              isContactPerson\n              person {\n                id\n                firstName\n                lastName\n                profilePictureId\n                profilePictureDefaultId\n                initials\n              }\n            }\n          }\n        }\n        financialNumbers @include(if: $loadMultiCurrency) {\n          billablePlannedTimeAndExpenses\n          actualRevenue\n          remainingRevenue\n          forecastRevenue\n          recognitionOpenRevenue\n          recognitionForecastRevenue\n          recognitionLockedRevenue\n          plannedCost\n          actualCost\n          forecastCost\n          remainingCost\n          plannedProfit\n          forecastProfit\n          invoiced\n          paid\n        }\n  financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {\n          billablePlannedTimeAndExpenses\n          actualRevenue\n          remainingRevenue\n          forecastRevenue\n          recognitionOpenRevenue\n          recognitionForecastRevenue\n          recognitionLockedRevenue\n          plannedCost\n          actualCost\n          forecastCost\n          remainingCost\n          plannedProfit\n          forecastProfit\n          invoiced\n          paid\n        }\n        financialNumbers @include(if: $loadSingleCurrency) {\n          billablePlannedTimeAndExpenses\n          actualRevenue\n          remainingRevenue\n          forecastRevenue\n          recognitionOpenRevenue\n          recognitionForecastRevenue\n          recognitionLockedRevenue\n          plannedCost\n          actualCost\n          forecastCost\n          remainingCost\n          plannedProfit\n          forecastProfit\n          invoiced\n          paid\n        }\n        isInProjectGroup\n        customProjectId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '23ba198ed6a18c8d9a3436f24d5947f4';
export default node;
